"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRAPH_REQUESTS = exports.URLS = exports.GRAPH_ENDPOINTS = exports.GRAPH_SCOPES = exports.isIE = exports.fetchMsGraph = exports.requiresInteraction = void 0;
require("react-app-polyfill/ie11");
require("react-app-polyfill/stable");
const axios_1 = __importDefault(require("axios"));
const UI_URL = process.env.UI_URL || "";
const requiresInteraction = (errorMessage) => {
    if (!errorMessage || !errorMessage.length) {
        return false;
    }
    return (errorMessage.indexOf("consent_required") > -1 ||
        errorMessage.indexOf("interaction_required") > -1 ||
        errorMessage.indexOf("login_required") > -1);
};
exports.requiresInteraction = requiresInteraction;
const fetchMsGraph = async (url, accessToken) => {
    const { data } = await axios_1.default.get(url, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return data;
};
exports.fetchMsGraph = fetchMsGraph;
const isIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ") > -1;
    const msie11 = ua.indexOf("Trident/") > -1;
    return msie || msie11;
};
exports.isIE = isIE;
exports.GRAPH_SCOPES = {
    OPENID: "openid",
    PROFILE: "profile",
    USER: "User.Read",
    GROUP: "Group.Read.All",
};
exports.GRAPH_ENDPOINTS = {
    ME: "https://graph.microsoft.com/v1.0/me/",
    GROUPS: "https://graph.microsoft.com/v1.0/me/memberOf",
};
exports.URLS = {
    REDIRECT: UI_URL,
    LOGOUT: UI_URL,
};
exports.GRAPH_REQUESTS = {
    LOGIN: {
        scopes: [
            exports.GRAPH_SCOPES.OPENID,
            exports.GRAPH_SCOPES.PROFILE,
            exports.GRAPH_SCOPES.USER,
            exports.GRAPH_SCOPES.GROUP,
        ],
    },
};
//# sourceMappingURL=utils.js.map